import React, { createContext, useState, useEffect, useCallback } from "react";
import { GetAllCart, GetAllCategory,  } from "../Libs/api";
import { toast } from "react-toastify";

const MyContext = createContext();
const MyContextProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [adminToken, setAdminToken] = useState(localStorage.getItem("adminToken"));
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [totalSalePrice, setTotalSalePrice] = useState("");
  const [totalOriginalPrice, setTotalOriginalPrice] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [allCart, setAllCart] = useState([]);
  const [clientDetails, setClientDetails] = useState(
    JSON.parse(localStorage.getItem("clientDetails") || "{}")
  );
  
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("userDetails") || "{}")
  );

  const updateClient = (newData) => {
    setClientDetails(newData);
    localStorage.setItem("clientDetails", JSON.stringify(newData));
  };

  const updateAdminToken = (newData) => {
    setAdminToken(newData);
    localStorage.setItem("adminToken", newData);
  };

  const updateUser = (newData) => {
    setUser(newData);
    localStorage.setItem("userDetails", JSON.stringify(newData));
  };

  const updateRole = (newData) => {
    setRole(newData);
    localStorage.setItem("role", newData);
  };

  const updateToken = (newData) => {
    console.log("newData: ", newData);
    setToken(newData);
    localStorage.setItem("token", newData);
  };

  const handleLogout = () => {
    setToken(null);
    setAllCart([]);
    setUser({});
    setClientDetails({});
    localStorage.removeItem("token");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("clientDetails");
  };

  const callCategotyAPI = useCallback(async () => {
    try {
      const apiCall = await GetAllCategory();
      if (apiCall.status === "1") {
        setAllCategory(apiCall?.AllCategory);
      } else {
        toast.error(apiCall?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
    // eslint-disable-next-line
  }, []);

  const callCartAPI = useCallback(async () => {
    try {
      let formData = new FormData();

      formData.append("Token", token)
      const apiCall = await GetAllCart(formData);

      if (apiCall.status === "1") {
        setAllCart(apiCall?.productlist);
        setTotalSalePrice(apiCall?.totalsaleprice)
        setTotalOriginalPrice(apiCall?.totalbuyprice)
      } else {
        toast.error(apiCall?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
    // eslint-disable-next-line
  }, [token]);

  return (
    <MyContext.Provider
      value={{
        token,
        updateToken,
        user,
        updateUser,
        setOpen,
        open,
        loading,
        setLoading,
        clientDetails,
        updateClient,
        allCategory,
        callCategotyAPI,
        allCart,
        callCartAPI,
        setAllCart,
        totalSalePrice,
        totalOriginalPrice,
        handleLogout,
        role,
        updateRole,
        adminToken,
        updateAdminToken
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export { MyContext, MyContextProvider };
